import {ActionTree} from "vuex";
import {TradeContractFormatGroup, TradeContractFormatGroupState} from "./model";
import {RootStateType} from "@/store";
import {AxiosResponse} from "axios";
import Qs from "qs";

const actions: ActionTree<TradeContractFormatGroupState, RootStateType> = {
  findList({ rootGetters, commit }, params) {
    const paramsHash = {
      params: params,
      paramsSerializer: function (params: object) {
        return Qs.stringify(params, { arrayFormat: 'brackets' })
      }
    }

    return rootGetters['hcs/client'].get('/trade_contract_format_groups', paramsHash)
      .then((response: AxiosResponse) => {
        const groups: TradeContractFormatGroup[] = response.data;
        commit('setTradeContractFormatGroups', groups)
        return groups
      })
  },
  get({ rootGetters, commit }, id) {
      return rootGetters['hcs/client'].get(`/trade_contract_format_groups/${id}`)
          .then((response: AxiosResponse) => {
              const group: TradeContractFormatGroup = response.data;
              commit('setTradeContractFormatGroups', [group])
              return group
          })
  },
  create({ rootGetters, commit }, params) {
    return rootGetters['hcs/client'].post('/trade_contract_format_groups', params)
      .then((response: AxiosResponse) => {
        const group: TradeContractFormatGroup = response.data;
        commit('addTradeContractFormatGroup', group)
        return group
      })
  },
  update({ rootGetters, commit }, params) {
    return rootGetters['hcs/client'].patch(`/trade_contract_format_groups/${params.id}`, params)
      .then((response: AxiosResponse) => {
        const group: TradeContractFormatGroup = response.data;
        commit(('updateTradeContractFormatGroup'), group)
        return group
      })
  },
  delete({ rootGetters, commit }, id) {
    return rootGetters['hcs/client'].delete(`/trade_contract_format_groups/${id}`)
      .then((response: AxiosResponse) => {
        commit(('deleteTradeContractFormatGroup'), id)
      })
  }
}

export default actions;
